import React from 'react';
import { useImmer } from 'use-immer';
import Rodal from 'rodal';

import Button from 'components/common/Button';
import CancelWhiteIcon from 'assets/cancel_white.svg';
import DeactivateTokenModal from './deactivateKeyModal';
import { useMediaQuery } from 'react-responsive';

import './index.css';

const ShowUserAccessKeysList = ({ accesskeys, updateProfileData }) => {
  const isDesktop = useMediaQuery({ minWidth: 1025 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [state, setState] = useImmer({
    toggleDeleteCredModal: false,
    credentialToDelete: null,
  });

  const onDeactivateAction = (item) => {
    setState((draft) => {
      draft.credentialToDelete = item;
      draft.toggleDeleteCredModal = true;
    });
  };

  const renderAccessKeys = () => {
    const renderKeys = accesskeys?.length ? (
      accesskeys
        .filter((item) => item.active)
        .map((item, index) => (
          <React.Fragment key={item?.access_key}>
            <div className="mx-2 my-2 flex items-center">
              <div className="w-5/6 lg:w-2/6 ">
                <span className="py-1 px-1 bg-yellow-200">
                  {item?.access_key}
                </span>
              </div>
              <div className="w-1/6 lg:w-4/6">
                <Button
                  intent="danger"
                  customClass="ml-1 sm:ml-0 bg-danger px-1 py-1 focus:outline-none"
                  onClick={() => {
                    onDeactivateAction(item);
                  }}
                >
                  <img width="22" height="22" src={CancelWhiteIcon} />
                </Button>
              </div>
            </div>
          </React.Fragment>
        ))
    ) : (
      <div className="mx-2 my-2">No access keys yet created</div>
    );

    return renderKeys;
  };

  const onCloseDeactivateKeyModal = () => {
    updateProfileData();
    setState((draft) => {
      draft.credentialToDelete = null;
      draft.toggleDeleteCredModal = false;
    });
  };

  return (
    <div className="mt-3">
      <div className="access-keys-list-render">{renderAccessKeys()}</div>
      <Rodal
        className="rodal-sort-container"
        visible={state.toggleDeleteCredModal}
        onClose={onCloseDeactivateKeyModal}
        customStyles={{
          width: isMobile || isTablet ? '90%' : '37%',
          height: isMobile || isTablet ? '230px' : '200px',
        }}
        closeMaskOnClick={true}
        closeOnEsc={true}
        animationType="enter"
        showCloseButton={true}
      >
        <DeactivateTokenModal
          credential={state.credentialToDelete}
          closeModal={onCloseDeactivateKeyModal}
        />
      </Rodal>
    </div>
  );
};

export default ShowUserAccessKeysList;
